import {
  Button,
  DateInput,
  SimpleForm,
  TextField,
  TextInput,
  WithRecord,
  WrapperField,
  ExportButton,
  TopToolbar,
  downloadCSV,
} from 'react-admin';
import jsonExport from 'jsonexport/dist';
import CraftEdit from 'src/components/CraftEdit';
import { CraftPageSection } from 'src/components/CraftPageSection';
import CraftSimpleFormToolbar from 'src/components/CraftSimpleFormToolbar';

import CraftStandaloneList from 'src/components/CraftStandaloneList';
import { Center } from 'src/components/Center';
import { UserReferenceField } from '../users/UserReferenceField';
import UserProgramDeleteButton from '../usersPrograms/DeleteButton';
import {
  AddProgramUsersDialog,
  AddProgramUsersDialogContextProvider,
  useAddProgramUsersDialogContext,
} from './AddProgramUsersDialog';
import { usePermissions } from 'src/hooks';

const AddUsersControls = () => {
  const dialog = useAddProgramUsersDialogContext();
  return (
    <>
      <Button label="Add users" variant="contained" onClick={dialog.setOpen} sx={{ mt: 2 }} />
      <AddProgramUsersDialog />
    </>
  );
};

const exporter = (
  records: Array<Record<string, unknown>>,
  fetchRelatedRecords: (
    data: Array<Record<string, unknown>>,
    field: string,
    resource: string,
  ) => Promise<Record<string | number, unknown>>,
) => {
  fetchRelatedRecords(records, 'user_id', 'users').then((usersById) => {
    const data = records.map((r) => {
      const userId = (r as { user_id?: string | number }).user_id;
      const user =
        userId !== undefined && userId !== null
          ? (usersById[userId] as { name?: string; email?: string; organization_id?: string | number } | undefined)
          : undefined;

      return {
        name: user?.name ?? user?.email ?? '',
        email: user?.email ?? '',
        org_id: user?.organization_id ?? '',
      };
    });

    return jsonExport(
      data,
      {
        headers: ['name', 'email', 'org_id'],
      },
      (err: Error | null, csv: string) => {
        if (err) return;
        downloadCSV(csv, 'program_users');
      },
    );
  });
};

export const PortalProgramsEdit = () => {
  const { permissions } = usePermissions();
  const canDelete = permissions.has('programs:delete');

  return (
    <CraftEdit header="Edit Program">
      <SimpleForm toolbar={<CraftSimpleFormToolbar />}>
        <CraftPageSection title="Details">
          <TextInput source="name" />
          <TextInput source="id" disabled />
          <TextInput source="key" disabled />
          <DateInput source="created_at" disabled />
        </CraftPageSection>
        <CraftPageSection title="Users">
          <WithRecord
            render={(record) => (
              <CraftStandaloneList
                resource="users_programs"
                filter={{ 'program_id@_eq': record?.id }}
                sort={{ field: 'created_at', order: 'DESC' }}
                perPage={10}
                actions={
                  <TopToolbar>
                    <ExportButton />
                    <AddProgramUsersDialogContextProvider>
                      <AddUsersControls />
                    </AddProgramUsersDialogContextProvider>
                  </TopToolbar>
                }
                exporter={exporter}
                deletePermission="programs:delete"
                dataGridProps={{ empty: <Center sx={{ my: 4 }}>No users found</Center> }}
              >
                <UserReferenceField source="user_id" />
                <TextField source="created_at" label="Added at" />
                <WrapperField label="Actions" headerClassName="column-actions" cellClassName="column-actions">
                  {canDelete && <UserProgramDeleteButton />}
                </WrapperField>
              </CraftStandaloneList>
            )}
          />
        </CraftPageSection>
      </SimpleForm>
    </CraftEdit>
  );
};
